<template>
  <GcBaseLayout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :baseView="baseView"
    :key="pageKey"
    :backButtonEnable="!!backButtonRoute"
    :backButtonFunction="backButtonFunction"
    :formsConfig="formsConfig"
    :tabs="getTabs"
    :selectedIndex="selectedTabIndex"
    ref="gc-base-layout"
    class="bill-of-materials"
    :routeChangeCallBack="onRouteChangeCallBack"
  >
    <slot></slot>

    <template #headerContent>
      <GcHeaderContentDynamic
        :title="'Bill of Materials'"
        :createModeIsEditMode="true"
        :baseView="baseView"
        :primaryLabel="'Bill of Materials # ' + formModel.BillNo"
        :secondaryLabel="undefined"
        v-if="loaded"
      />
    </template>

    <div class="split-view-template css-v2 split-view">
      <gc-split-view
        :showLeftContainer="showLeftContainer"
        :showRightContainer="showRightContainer"
      >
        <template #leftContent>
          <div class="css-v2 split-view-list">
            <dx-data-grid
              :height="getGridHeight"
              :columns="getGridColumns"
              :data-source="getDataSource"
              @toolbar-preparing="onToolbarPreparing($event)"
              @content-ready="onContentReady"
              @editor-preparing="onEditorPreparing"
              ref="data-grid"
              :columnChooser="{
                enabled: false,
              }"
              @row-click="onRowClick"
            >
              <DxPaging :page-size="200" :enabled="false" />

              <DxPager :visible="false" />

              <template #RecordTemplate="{ data }">
                <GcRecordCell
                  :data="data"
                  :primary="[
                    {
                      dataField: 'ProcessDescription',
                    },
                  ]"
                  :secondary="[
                    {
                      dataField: 'ProcessCode',
                    },
                  ]"
                />
              </template>
              <DxScrolling
                :mode="'virtual'"
                :row-rendering-mode="'virtual'"
                :preload-enabled="true"
              />
            </dx-data-grid>
          </div>
        </template>

        <template #rightContent>
          <gc-form-header-toolbar
            :toolbar-options="getHeaderToolbar"
            :data-model="formModel"
            :backRoute="getFormBackURL"
            :formLocation="'Left'"
            v-if="loaded"
            :baseView="baseView"
            :customButtons="getHeaderToolbar.customButtons"
          ></gc-form-header-toolbar>

          <div class="view-card responsive-paddings split-view-form">
            <GcForm
              :formOptions="formOptions"
              :formItems="getFormItems"
              :isNormal="true"
              :data-model="formModel"
              v-if="loaded"
              :formMode="baseView.mode"
              :valueChangeCallBack="valueChangeCallBack"
              :checkValid="isValid"
              :validationGroup="'split-view-form'"
              :formLocation="'normal'"
              :formContentReady="formContentReady"
              :formHeight="getFormHeight"
              ref="split-view-form"
            />
          </div>
        </template>
      </gc-split-view>
    </div>
  </GcBaseLayout>
</template>

<script>
import DataGridMixin from "@/_mixins/data-grid.mixin";
import FormMixin from "@/_mixins/form.mixin";
import RouteMixin from "@/_mixins/route.mixin";

import {
  BillOfMaterialsTabs,
  GetIndexByTabName,
} from "../../../_models/tabdata/production/bill-of-materials-tabs";
import { mapGetters } from "vuex";
import ColumnWidth from "../../../_helpers/data-grid/ColumnWidth";
import { FeatureStorage } from "../../../_services/storage";
import { BillOfMaterialsService } from "../../../_services/api/production/bill-of-materials.service";
import { ProductCostService } from "../../../_services/api/products/product-cost.service";
import { ProductSupplierService } from "../../../_services/api/products/product-supplier.service";
import { IsResponseDataValid } from "../../../_helpers/ui/helpers";
import { custom } from "devextreme/ui/dialog";
export default {
  name: "BillOfMaterialsMaterial",
  mixins: [RouteMixin, FormMixin, DataGridMixin],
  components: {},
  data() {
    return {
      loaded: false,
      formModel: {
        BillNo: undefined,
        DateChanged: null,
        DateCreated: null,
        CreatedBy: null,
        ChangedBy: null,
        ProcessCode: null,
        ProcessDisplayText: null,

        Material: null,
        MaterialType: "S",
        MaterialDisplayText: null,

        Unit: null,
        SupplierCode: null,
        SupplierDisplayText: null,

        AutoIssueStrategy: "None",
        IsFixedMaterial: false,
        IsShopFloorSubstitutionMaterial: false,
        ProcessNominalTree: false,
        IsShopFloorIssueMaterial: true,
        IsBatchExpiryMaterial: false,
        Quantity: 0.0,
        ProcessedQty: 0.0,
        YeildPercent: 0.0,
        StandardCost: 0.0,
        TotalCost: 0.0,
        Comment: null,
        ProductSource: null,
        WipLeadDays: 0,
      },
      isValid: false,
      formOptions: {
        gcLabelLocation: "left",
      },
      formHeight: "auto",
      AddedProductsList: [],
      SaveType: null,
      ClickedRowData: null,
      nextPathTo: null,
    };
  },
  async created() {
    if (this.baseView.mode === "create") {
      this.formModel.BillNo = this.baseView.id;
    } else {
      if (
        (this.baseView.mode === "review" || this.baseView.mode === "edit") &&
        this.baseView.id.length == 36
      ) {
        await this.getBomMaterialByRecordId();
      } else {
        this.formModel.BillNo = JSON.parse(JSON.stringify(this.baseView.id));
      }
    }
    this.$nextTick(() => {
      this.loaded = true;

      this.focusOnForm();
    });
  },
  async mounted() {},
  beforeDestroy() {},

  computed: {
    ...mapGetters({ gridHeight: "ui/getHeightForDataGrid" }),
    ...mapGetters({ getHotKeySave: "hotKey/getHotKeySave" }),
    backButtonRoute() {
      return "/bill-of-materials";
    },

    getFormBackURL() {
      return "/bill-of-materials-material/" + this.formModel.BillNo;
    },
    getTabs() {
      return BillOfMaterialsTabs(this.setBaseView);
    },
    selectedTabIndex() {
      return GetIndexByTabName("Materials", this.setBaseView);
    },

    setBaseView() {
      let baseView = { ...this.baseView };
      baseView.id = this.formModel.BillNo;

      return baseView;
    },
    showLeftContainer() {
      return true;
    },

    showRightContainer() {
      if (
        (this.baseView.mode == "review" || this.baseView.mode == "edit") &&
        this.baseView.id.length < 36
      ) {
        return false;
      }

      return !(this.baseView.mode == "review" && this.baseView.id == "");
    },
    getGridHeight() {
      return this.gridHeight - 20;
    },

    getGridColumns() {
      return [
        {
          caption: "Process",
          dataField: "ProcessCode",
          allowSorting: false,
          width: ColumnWidth.ProductCode.width,
          minWidth: ColumnWidth.ProductCode.minWidth + 50,
          cellTemplate: "RecordTemplate",
        },
        {
          caption: "Material",
          dataField: "MaterialCode",
          allowSorting: false,
          // width: ColumnWidth.ProductCode.width,
          minWidth: ColumnWidth.ProductCode.minWidth + 50,
          cellTemplate: (data, info) => {
            return (data.innerHTML = `<div class="custom-auto-complete">
                        <span class="auto-complete-primary">
                          ${info.data.MaterialDescription || ""}
                        </span>
                      <span class="record-secondary gc-grid-code">
                        ${info.data.MaterialCode}
                      </span>
                    </div>`);
          },
        },
        {
          caption: "Fixed",
          dataField: "IsFixedMaterial",
          allowSorting: false,
          width: ColumnWidth.UnitOfMeasure.width,
          minWidth: ColumnWidth.UnitOfMeasure.minWidth,
          falseText: "N",
          showEditorAlways: false,
          trueText: "Y",
        },
        {
          caption: "UM",
          dataField: "Unit",
          allowSorting: false,
          width: ColumnWidth.UnitOfMeasure.width,
          minWidth: ColumnWidth.UnitOfMeasure.minWidth,
        },
        {
          caption: "Type",
          dataField: "Type",
          allowSorting: false,
          width: ColumnWidth.Quantity2DecimalPoints.width,
          minWidth: ColumnWidth.Quantity2DecimalPoints.minWidth,
          calculateDisplayValue: (e) => {
            if (e.Type === "S") return "Stock";
            if (e.Type === "P") return "Purchased";
            else return "";
          },
        },
        {
          caption: "Quantity",
          dataField: "Qty",
          allowSorting: false,
          dataType: "number",
          width: ColumnWidth.Quantity4DecimalPoints.width,
          minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
          format: "##,###,###,###,##0.0000",
        },
        {
          caption: "Unit Cost",
          dataField: "UnitCost",
          allowSorting: false,
          dataType: "number",
          width: ColumnWidth.Quantity4DecimalPoints.width,
          minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
          format: "##,###,###,###,##0.0000",
        },
        {
          caption: "Material Cost",
          dataField: "MaterialCost",
          allowSorting: false,
          dataType: "number",
          width: ColumnWidth.Quantity4DecimalPoints.width,
          minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
          format: "##,###,###,###,##0.0000",
        },
        {
          caption: "Sequence",
          dataField: "Sequence",
          dataType: "number",
          visible: false,
        },
      ];
    },

    getDataSource() {
      return BillOfMaterialsService.dataSourceConfig("api/BomMaterialList", {
        filter: [["BomCode", "=", this.formModel.BillNo]],
        sort: [
          { selector: "Sequence", asc: true },
          { selector: "MaterialCode", asc: true },
        ],
      });
    },

    getHeaderToolbar() {
      return {
        closeSplit: true,
        save: this.isUserEntryAllowed && this.baseView.mode === "review",
        audit: true,
        auditItems: [
          {
            itemType: "group",
            caption: "",
            items: [
              {
                dataField: "FormattedDateCreated",
                label: { text: "Created By", location: "left" },
                editorType: "dxTextBox",
                editorOptions: {
                  disabled: true,
                },
              },
              {
                dataField: "FormattedDateChanged",
                label: { text: "Changed By", location: "left" },
                editorType: "dxTextBox",
                editorOptions: {
                  disabled: true,
                },
              },
            ],
          },
        ],
        toolbarFormLocation: "after",
        editURL: "/bill-of-materials-material",
        editCallBack: this.editCallBack,
        delete:
          this.baseView.mode !== "create" && this.isUserEntryAllowed
            ? true
            : false,
        deleteCallBack: this.deleteCallBack,

        customButtons:
          this.isUserEntryAllowed && this.baseView.mode !== "review"
            ? [
                {
                  widget: "dxDropDownButton",
                  icon: "floppy",
                  text: "",
                  showArrowIcon: false,
                  items: [
                    {
                      text: "Save + Add New",
                      type: "normal",
                    },
                    {
                      text: "Save + Preview",
                      type: "normal",
                    },
                    {
                      text: "Save & Close",
                      type: "normal",
                    },
                  ],
                  dropDownOptions: {
                    width: 120,
                  },
                  onItemClick: this.onSaveMaterial,
                },
              ]
            : undefined,
      };
    },
    getFormHeight() {
      if (this.formConfig && this.formConfig.formHeight)
        return this.formConfig.formHeight;
      else return "auto";
    },

    getProductCodeSource() {
      let url =
        "api/BomMaterialAvailableProductList?bomCode=" + this.formModel.BillNo + "&processCode=" + (this.formModel.ProcessCode || "");
      if ((this.baseView.mode === "review" || this.baseView.mode === "edit") && this.baseView.id) {
        url += "&recordId=" + this.baseView.id;
      }
                
      return BillOfMaterialsService.dataSourceConfig(url, {
        sort: "Code asc",
        select:
          "Code,Description1,Inactive, RecordId, UnitOfMeasureCode,Status,Source",
        paginate: true,
      });
    },

    getFormItems() {
      return [
        {
          itemType: "group",
          caption: "",
          colCount: 1,
          items: [
            {
              dataField:
                this.baseView.mode === "review"
                  ? "ProcessDisplayText"
                  : "ProcessCode",
              label: { text: "Process", location: "left" },
              editorType:
                this.baseView.mode === "review" ? "dxTextBox" : "dxSelectBox",
              editorOptions: {
                dataSource: BillOfMaterialsService.dataSourceConfig(
                  "api/BomProcessList",
                  {
                    filter: ["BomCode", "=", this.formModel.BillNo],
                    sort: "ProcessCode asc",
                  },
                ),
                valueExpr: "ProcessCode",
                displayExpr: (item) => {
                  if (item)
                    return item.ProcessCode + " - " + item.ProcessDescription;
                  else return "";
                },
                searchEnabled: true,
                showClearButton: true,
                placeholder: "Select Process",
                onValueChanged: (e) => {
                  if (e.event && e.value) {
                    this.onProcessCodeChange(e);
                  }
                },
                tabIndex: 1,
                onFocusIn: (e) => {
                  e.event.target.select();
                },
                itemTemplate: (data) => {
                  return ` <div class="custom-auto-complete" id="${data.ProcessCode}" >
                            <span class="auto-complete-primary">
                              ${data.ProcessCode}
                            </span>
                            <span class="record-secondary gc-grid-code">
                              ${data.ProcessDescription}
                            </span>
                          </div>`;
                },
                searchExpr: ["ProcessCode", "ProcessDescription"],
              },
              validationRules: [
                {
                  type: "required",
                  message: "Process is required",
                },
              ],
            },
            {
              dataField:
                this.baseView.mode === "review"
                  ? "MaterialDisplayText"
                  : "Material",
              label: { text: "Material" },
              editorType:
                this.baseView.mode === "review" ? "dxTextBox" : "dxSelectBox",
              required: true,
              editorOptions: {
                tabIndex: 2,
                // dataSource:
                //   this.baseView.mode !== "create"
                //     ? this.getProductCodeSource
                //     : [],
                dataSource: this.getProductCodeSource,
                searchEnabled: true,
                showClearButton: true,
                valueExpr: "Code",
                displayExpr: (item) => {
                  if (item) return item.Code + " - " + item.Description1;
                  else return "";
                },
                itemTemplate: (data) => {
                  return ` <div class="custom-auto-complete" id="${data.Code}" >
                            <span class="auto-complete-primary">
                              ${data.Code}
                            </span>
                            <span class="record-secondary gc-grid-code">
                              ${data.Description1}
                            </span>
                          </div>`;
                },
                onFocusIn: (e) => {
                  e.event.target.select();
                },
                // onFocusIn: async (e) => {
                //   if (!e.event) return;
                //   const selectBox = e.component;
                //   selectBox.beginUpdate();
                //   selectBox.option("dataSource", this.getProductCodeSource);
                //   selectBox.endUpdate();
                //   await this.$nextTick();
                //   setTimeout(() => {
                //     selectBox.focus();
                //     this.$nextTick(() => {
                //       e.event.target.select();
                //     });
                //   }, 200);
                // },
                searchExpr: ["Code", "Description1"],
                onValueChanged: this.onMaterialSelectionChanged,
              },
            },
            {
              itemType: "group",
              caption: "",
              colCount: 2,
              items: [
                {
                  dataField: "Unit",
                  label: { text: "UM" },
                  editorOptions: {
                    readOnly: true,
                  },
                },
                {
                  dataField: "MaterialType",
                  label: { text: "Material Type" },
                  editorType: "dxSelectBox",
                  cssClass: "material-type",
                  required: true,
                  editorOptions: {
                    dataSource: [
                      { Type: "S", Text: "Stock" },
                      { Type: "P", Text: "Purchased" },
                    ],
                    valueExpr: "Type",
                    displayExpr: "Text",
                    searchEnabled: true,
                    showClearButton: true,
                    placeholder: "Select Material Type",
                    tabIndex: 3,
                    onFocusIn: (e) => {
                      e.event.target.select();
                    },
                    onValueChanged: this.onMaterialTypeSelectionChanged,
                  },
                },
              ],
            },
            {
              cssClass: "supplier-code",
              dataField:
                this.baseView.mode === "review"
                  ? "SupplierDisplayText"
                  : "SupplierCode",
              editorType:
                this.baseView.mode === "review" ? "dxTextBox" : "dxSelectBox",
              editorOptions: {
                tabIndex: 4,
                dataSource: ProductSupplierService.dataSourceConfig(
                  "api/ProductSupplierList",
                  {
                    filter: [["ProductCode", "=", this.formModel.Material]],
                    select: ["SupplierCode", "SupplierName"],
                  },
                ),
                valueExpr: "SupplierCode",
                displayExpr: (item) => {
                  if (item)
                    return item.SupplierCode + " - " + item.SupplierName;
                  else return "";
                },
                searchEnabled: true,
                showClearButton: true,
              },
              validationRules: [
                {
                  type: "custom",
                  validationCallback: ({ value, rule }) => {
                    rule.message = `Supplier is required`;
                    return !(
                      this.formModel.MaterialType === "P" && value == null
                    );
                  },
                  reevaluate: true,
                },
              ],
            },
            {
              dataField: "AutoIssueStrategy",
              label: { text: "Auto Issue" },
              editorType: "dxSelectBox",
              editorOptions: {
                tabIndex: 5,
                dataSource: [
                  { Text: "None" },
                  { Text: "Include Waste" },
                  { Text: "Exclude Waste" },
                ],
                valueExpr: "Text",
                displayExpr: "Text",
                onFocusIn: (e) => {
                  e.event.target.select();
                },
              },
            },
          ],
        },
        {
          itemType: "group",
          caption: "",
          colCount: 2,
          items: [
            {
              dataField: "IsFixedMaterial",
              label: { text: "Fixed Material" },
              editorType: "dxSwitch",
              editorOptions: {
                tabIndex: 6,
              },
            },
            {
              dataField: "IsShopFloorSubstitutionMaterial",
              label: { text: "Shopfloor Substitution" },
              editorType: "dxSwitch",
              editorOptions: {
                tabIndex: 7,
              },
            },
            {
              dataField: "IsShopFloorIssueMaterial",
              label: { text: "Shopfloor Issue" },
              editorType: "dxSwitch",
              editorOptions: {
                tabIndex: 8,
              },
            },
            {
              dataField: "ProcessNominalTree",
              label: { text: "Process Nominal Tree" },
              editorType: "dxSwitch",
              editorOptions: {
                tabIndex: 9,
                onValueChanged: this.onProcessNominalTreeChanged,
              },
            },
            {
              dataField: "IsBatchExpiryMaterial",
              label: { text: "Batch Expiry Material" },
              editorType: "dxSwitch",
              editorOptions: {
                tabIndex: 10,
              },
            },
            {
              dataField: "WipLeadDays",
              label: { text: "WIP Lead Days" },
              editorType: "dxNumberBox",
              cssClass: "wip-lead-days",
              editorOptions: {
                tabIndex: 11,
                min: 0,
              },
            },
          ],
        },
        {
          dataField: "Quantity",
          label: { text: "Quantity", location: "left" },
          editorType: "dxNumberBox",
          editorOptions: {
            format: "##,###,###,###,##0.0000",
            tabIndex: 11,
            onValueChanged: this.onQuantityValueChanged,
          },
          required: true,
        },
        {
          dataField: "ProcessedQty",
          label: { text: "Processed Quantity", location: "left" },
          editorType: "dxNumberBox",
          editorOptions: {
            format: "##,###,###,###,##0.0000",
            tabIndex: 12,
            onValueChanged: this.onProcessedQtyChanged,
          },
        },
        {
          dataField: "YeildPercent",
          label: { text: "Yield %", location: "left" },
          editorType: "dxNumberBox",
          editorOptions: {
            format: "##,###,###,###,##0.0000",
            tabIndex: 13,
            onValueChanged: this.onYeildPercentChanged,
          },
          validationRules: [
            {
              type: "range",
              message: "Yield % must be a positive value",
              min: 0,
            },
          ],
        },
        {
          dataField: "StandardCost",
          label: { text: "Standard Cost", location: "left" },
          editorType: "dxNumberBox",
          editorOptions: {
            readOnly: true,
            format: "##,###,###,###,##0.0000",
            tabIndex: -1,
          },
        },
        {
          dataField: "TotalCost",
          label: { text: "Total Cost", location: "left" },
          editorType: "dxNumberBox",
          editorOptions: {
            format: "##,###,###,###,##0.0000",
            tabIndex: -1,
            readOnly: true,
          },
        },
        {
          dataField: "Comment",
          label: { text: "Comment", location: "top" },
          editorType: "dxTextArea",
          cssClass: "comment-textarea",
          editorOptions: {
            height: 90,
            maxLength: 1000,
            showClearButton: true,
            tabIndex: 16,
          },
        },
      ];
    },

    isUserEntryAllowed() {
      return FeatureStorage.checkPermission("BillOfMaterial", "create");
    },
  },
  methods: {
    async editCallBack() {
      await this.setSupplierDisabled();
      await this.setMaterialTypeDisabled();
      this.$nextTick(() => {
        this.focusOnForm();
      });
    },
    backButtonFunction() {
      this.$router
        .push({
          path: this.backButtonRoute,
        })
        .then(() => {
          this.$store.dispatch("dataContext/setDataViewType", undefined);
        });
    },

    onToolbarPreparing(e) {
      var toolbarItems = e.toolbarOptions.items;
      var searchPanel = toolbarItems.find((item) => {
        return item.name === "searchPanel";
      });

      e.toolbarOptions.items = toolbarItems.filter((item) => {
        return (
          item.name !== "searchPanel" && item.name !== "columnChooserButton"
        );
      });
      searchPanel.location = "after";

      e.toolbarOptions.items.unshift(
        {
          location: "before",
          widget: "dxButton",
          options: {
            icon: "plus",
            text: "Add New",
            visible: this.isUserEntryAllowed,
            onClick: async () => {
              if (this.baseView.mode !== "review") {
                let confirmLeaving = await this.$confirm(
                  "You have unsaved changes. Are you sure you want to leave?",
                  "Unsaved changes",
                );

                if (confirmLeaving) {
                  this.setIgnoreRouteChangeConfirmation();
                  this.createNewMaterial();
                }
              } else {
                this.createNewMaterial();
              }
            },
            // disabled: true,
          },
        },
        searchPanel,
      );
    },

    async createNewMaterial() {
      await this.resetFormToDefault();
      this.$router
        .push({
          path: `/bill-of-materials-material/create/${this.formModel.BillNo}`,
        })
        .then(() => {
          this.$nextTick(() => {
            this.focusOnForm();
          });
        });
    },

    /**
     * Reset Form To Default
     */
    async resetFormToDefault() {
      this.formModel.ProcessCode = null;
      this.formModel.Material = null;
      this.formModel.MaterialType = "S";
      this.formModel.SupplierCode = null;
      this.formModel.AutoIssueStrategy = "None";
      this.formModel.IsFixedMaterial = false;
      this.formModel.IsShopFloorSubstitutionMaterial = false;
      this.formModel.ProcessNominalTree = false;
      this.formModel.IsShopFloorIssueMaterial = true;
      this.formModel.IsBatchExpiryMaterial = false;
      this.formModel.Quantity = 0.0;
      this.formModel.ProcessedQty = 0.0;
      this.formModel.YeildPercent = 0.0;
      this.formModel.StandardCost = 0.0;
      this.formModel.TotalCost = 0.0;
      this.formModel.Comment = null;
      this.formModel.ProductSource = null;
    },

    /**
     * Focus On Form
     */
    focusOnForm(dataField = "ProcessCode") {
      setTimeout(() => {
        this.$nextTick(() => {
          if (
            this.$refs["split-view-form"] &&
            this.$refs["split-view-form"].$refs["gc-form-comp"]
          ) {
            const formInstance =
              this.$refs["split-view-form"].$refs["gc-form-comp"].instance;
            if (formInstance) {
              const firstElement = formInstance.getEditor(dataField);
              if (firstElement) {
                firstElement.focus();
              }
            }
          }
        });
      }, 150);

      setTimeout(() => {
        this.setWIPLeadDaysVisibility();
      }, 100);
    },

    onEditorPreparing() {
      // if (this.baseView.mode === "edit") {
      //   this.$nextTick(() => {
      //     setTimeout(() => {
      //       this.setSupplierDisabled();
      //       this.setMaterialTypeDisabled();
      //     }, 200);
      //   });
      // }
    },

    /**
     * On Content Ready
     * @param e Event
     */
    onContentReady(e) {
      if (e) {
        this.addGridNoResults(e, {
          addNew: {
            class: "add-new",
            title: "No Materials",
            message:
              "There are no materials linked to this Bill of Materials. Add a new material.",
          },
        });
      }
      this.$nextTick(() => {
        this.reSizeGrid(e.component);
      });
    },

    /**
     * Resize Grid
     * @param component Grid Component
     */
    reSizeGrid(component) {
      component.beginUpdate();
      component.updateDimensions();
      component.endUpdate();
    },

    /**
     * Form Content Ready
     * @param e Event
     */
    formContentReady(e) {
      if (e)
        this.formHeight =
          this.heigthForForm -
          document.getElementsByClassName("form-header-toolbar")[0]
            .clientHeight -
          40;
    },

    /**
     * Value Change Call Back
     * @param isValid Validation Status
     * @param brokenRules
     */
    async valueChangeCallBack(isValid, brokenRules) {
      if (!isValid) this.displayValidationSummary(brokenRules);
      else {
        this.SaveBomNewMaterial();
      }

      this.$nextTick(() => {
        this.isValid = false;
      });
    },

    /**
     * Save Bom New Material
     */
    async SaveBomNewMaterial() {
      this.showLoading(true);

      try {
        const response = await BillOfMaterialsService.SaveBomNewMaterial(
          this.getPayload(),
        );

        if (!response) return;
        this.setIgnoreRouteChangeConfirmation();

        // Case 1 – Save + Add New
        if (this.SaveType === "Save + Add New") {
          await this.handleSaveAddNew();
          return;
        }

        // Case 2 – Save + Preview / Save + Edit
        if (
          this.SaveType === "Save + Preview" ||
          this.SaveType === "Save + Edit"
        ) {
          await this.handleSavePreviewOrEdit(response);
          this.$refs["data-grid"].instance.getDataSource().reload();
          return;
        }

        // Case 3 – Save + Move (route change)
        if (this.SaveType === "Save + Move" && this.nextPathTo) {
          await this.$router.push({ path: this.nextPathTo });
          return;
        }

        // Default (normal save)
        this.goBackToList();
      } catch (error) {
        this.displayServerError(
          error,
          "Error saving Process to Bill of Materials",
        );
      } finally {
        this.showLoading(false);
      }
    },

    /**
     * Handles Save + Add New action
     */
    async handleSaveAddNew() {
      await this.$refs["data-grid"].instance.refresh();
      await this.$nextTick();

      if (this.baseView.mode !== "create") {
        this.createNewMaterial();
        return;
      }

      await this.resetFormToDefault();

      setTimeout(() => {
        this.$nextTick(() => this.focusOnForm());
      }, 200);
    },

    /**
     * Handles Save + Preview or Save + Edit actions
     * @param response
     */
    async handleSavePreviewOrEdit(response) {
      const isPreview =
        !this.ClickedRowData || this.SaveType === "Save + Preview";

      const processCode = isPreview
        ? this.formModel.ProcessCode
        : this.ClickedRowData.ProcessCode;

      const material = isPreview
        ? this.formModel.Material
        : this.ClickedRowData.MaterialCode;

      // Find the record ID from the API response
      const record = response.data.BomNewMaterialDetails.find(
        (x) => x.ProcessCode === processCode && x.ProductCode === material,
      );

      if (!record) {
        this.goBackToList();
        return;
      }

      const pathName = isPreview
        ? "bill-of-materials-material-review"
        : "bill-of-materials-material-edit";

      await this.$router.push({
        name: pathName,
        params: { id: record.RecordId },
      });

      this.$nextTick(() => this.getBomMaterialByRecordId());
    },

    goBackToList() {
      this.$nextTick(() => {
        this.setIgnoreRouteChangeConfirmation();
        this.$router
          .push({
            path: this.getFormBackURL,
          })
          .then(() => {
            this.$refs["data-grid"].instance.refresh();
          });
      });
    },

    getPayload() {
      const items = this.$refs["data-grid"].instance.getDataSource().items();
      let BomNewMaterialDetails = [];

      BomNewMaterialDetails = items
        .filter((x) => x.RecordId._value !== this.baseView.id)
        .map((x) => ({
          ProcessCode: x.ProcessCode,
          ProductCode: x.MaterialCode,
          Type: x.Type,
          SupplierCode: x.SupplierCode,
          AutoIssueStrategy: x.AutoIssueStrategy,
          IsFixedMaterial: x.IsFixedMaterial,
          ProcessNominalTree: x.ProcessNominalTree,
          IsBatchExpiryMaterial: x.IsBatchExpiryMaterial,
          IsShopFloorSubstitutionMaterial: x.IsShopFloorSubstitutionMaterial,
          IsShopFloorIssueMaterial: x.IsShopFloorIssueMaterial,
          Qty: x.Qty,
          ProcessQty: x.ProcessQty,
          YieldPct: x.YieldPct,
          ExTaxUnitCost: x.UnitCost,
          Comment: x.Comments,
          RecordId: x.RecordId,
          WIPLeadDays: x.WipLeadDays || 0,
        }));

      BomNewMaterialDetails.push({
        ProcessCode: this.formModel.ProcessCode || "",
        ProductCode: this.formModel.Material || "",
        Type: this.formModel.MaterialType || "",
        SupplierCode: this.formModel.SupplierCode || "",
        AutoIssueStrategy: this.formModel.AutoIssueStrategy,
        IsFixedMaterial: this.formModel.IsFixedMaterial,
        ProcessNominalTree: this.formModel.ProcessNominalTree ? "Y" : "N",
        IsBatchExpiryMaterial: this.formModel.IsBatchExpiryMaterial ? "Y" : "N",
        IsShopFloorSubstitutionMaterial: this.formModel
          .IsShopFloorSubstitutionMaterial
          ? "Y"
          : "N",
        IsShopFloorIssueMaterial: this.formModel.IsShopFloorIssueMaterial
          ? "Y"
          : "N",
        Qty: this.formModel.Quantity,
        ProcessQty: this.formModel.ProcessedQty,
        YieldPct: this.formModel.YeildPercent,
        ExTaxUnitCost: this.formModel.StandardCost,
        Comment: this.formModel.Comment || "",
        RecordId:
          this.baseView.mode === "create"
            ? "00000000-0000-0000-0000-000000000000"
            : this.baseView.id,
        WIPLeadDays: this.formModel.WipLeadDays || 0,
      });

      return {
        BomCode: this.formModel.BillNo,
        BomNewMaterialDetails: BomNewMaterialDetails,
      };
    },

    /**
     * Show Unsaved Changes Dialog
     */
    showUnsavedChangesDialog() {
      return custom({
        title: "Unsaved Changes",
        messageHtml: `You have unsaved changes. Do you want to discard your changes or save them before proceeding?`,
        buttons: [
          {
            text: "Save Changes",
            onClick: (e) => ({ buttonText: e.component.option("text") }),
          },
          {
            text: "Discard Changes",
            onClick: (e) => ({ buttonText: e.component.option("text") }),
          },
        ],
      }).show();
    },

    /**
     * Handle Unsaved Navigation
     * @param {Function} saveCallback - Callback function to execute when saving changes.
     * @param {Function} discardCallback - Callback function to execute when discarding changes.
     */
    async handleUnsavedNavigation(saveCallback, discardCallback) {
      this.setIgnoreRouteChangeConfirmation();

      const dialogResult = await this.showUnsavedChangesDialog();

      if (dialogResult.buttonText === "Save Changes") {
        await saveCallback();
      } else {
        await discardCallback();
      }
    },

    /**
     * On Row Click
     * @param e Event
     */
    async onRowClick(e) {
      if (e.event) {
        const data = e.data;
        this.ClickedRowData = e.data;

        if (data.RecordId._value === this.baseView.id) return;

        if (this.baseView.mode === "edit") {
          await this.handleUnsavedNavigation(
            async () => {
              await this.onSaveMaterial({ itemData: { text: "Save + Edit" } });
            },
            async () => {
              // Setting these values omits the Form calling data sources for these fields again
              this.formModel.Material = this.ClickedRowData.MaterialCode;
              this.formModel.ProcessCode = this.ClickedRowData.ProcessCode;
              this.formModel.SupplierCode = this.ClickedRowData.SupplierCode;

              await this.$router.push({
                name: "bill-of-materials-material-edit",
                params: { id: this.ClickedRowData.RecordId },
              });
              this.$nextTick(() => this.getBomMaterialByRecordId());
            },
          );
        } else {
          this.$router
            .push({
              name: "bill-of-materials-material-review",
              params: { id: data.RecordId },
            })
            .then(() => {
              this.$nextTick(() => {
                this.getBomMaterialByRecordId();
              });
            });
        }
      }
    },

    /**
     * On Route Change Call Back
     * @param {string} pathTo - The path to navigate to.
     */
    async onRouteChangeCallBack(pathTo) {
      this.nextPathTo = pathTo;

      await this.handleUnsavedNavigation(
        async () => {
          await this.onSaveMaterial({ itemData: { text: "Save + Move" } });
        },
        async () => {
          await this.$router.push({ path: pathTo });
          this.$nextTick(() => this.getBomMaterialByRecordId());
        },
      );
    },

    /**
     * Get Bom Material By Record Id
     */
    async getBomMaterialByRecordId() {
      this.showLoading(true);

      this.setWIPLeadDaysVisibility();
      try {
        const response = await BillOfMaterialsService.getBomMaterialByRecordId(
          this.baseView.id,
        );

        if (IsResponseDataValid(response)) {
          const data = response.data.value[0];
          this.formModel.BillNo = data.BomCode;
          this.formModel.ProcessCode = data.ProcessCode;
          this.formModel.ProcessDisplayText =
            data.ProcessCode + " - " + data.ProcessDescription;

          this.formModel.Material = data.MaterialCode;
          this.formModel.MaterialDisplayText =
            data.MaterialCode + " - " + data.MaterialDescription;

          this.formModel.MaterialType = data.Type;
          this.formModel.SupplierCode = data.SupplierCode;

          this.formModel.SupplierDisplayText =
            data.SupplierCode && data.SupplierName
              ? data.SupplierCode + " - " + data.SupplierName
              : null;

          this.formModel.AutoIssueStrategy = data.AutoIssueStrategy;
          this.formModel.IsFixedMaterial = data.IsFixedMaterial;
          this.formModel.IsShopFloorSubstitutionMaterial =
            data.IsShopFloorSubstitutionMaterial === "Y";
          this.formModel.ProcessNominalTree = data.ProcessNominalTree === "Y";
          this.formModel.IsShopFloorIssueMaterial =
            data.IsShopFloorIssueMaterial === "Y";
          this.formModel.IsBatchExpiryMaterial =
            data.IsBatchExpiryMaterial === "Y";

          this.formModel.Quantity = data.Qty;
          this.formModel.ProcessedQty = data.ProcessQty;
          this.formModel.YeildPercent = data.YieldPct;
          this.formModel.StandardCost = data.UnitCost;
          this.formModel.TotalCost = (data.Qty * data.UnitCost).roundNumber(4);

          this.formModel.Comment = data.Comments;
          this.formModel.ProductSource = data.ProductSource;
          this.formModel.Unit = data.Unit;

          this.formModel.DateChanged = data.DateChanged;
          this.formModel.DateCreated = data.DateCreated;
          this.formModel.ChangedBy = data.ChangedBy;
          this.formModel.CreatedBy = data.CreatedBy;

          this.formModel.WipLeadDays = data.WipLeadDays;
        }
      } catch (error) {
        this.displayServerError(error);
      } finally {
        this.showLoading(false);

        this.$nextTick(() => {
          this.setWIPLeadDaysVisibility();
        });
      }
    },

    /**
     * On Process Code Change
     * @param e Event
     */
    onProcessCodeChange(e) {
      this.formModel.ProcessCode = e.value;
    },

    /**
     * On Material Selection Changed
     * @param e Event
     */
    onMaterialSelectionChanged(e) {
      if (!e.value || !e.event) return;
      let instance = e.component;
      this.formModel.Material = e.value;

      let selectedItem = instance.getDataSource()
        ? instance
            .getDataSource()
            .items()
            .find((x) => x.Code === e.value)
        : null;

      if (selectedItem) {
        this.setStandardCost(selectedItem.Code);

        this.$nextTick(() => {
          this.formModel.Material = selectedItem.Code;
          this.formModel.ProductSource = selectedItem.Source;
          this.formModel.SupplierCode = null;

          this.setMaterialType();
          this.validateForm();
          this.updateFormValues("Material", this.formModel.Material);
        });
      }
    },

    setMaterialType() {
      if (this.formModel.ProductSource == "M") {
        this.formModel.MaterialType = "S";
      } else {
        // this.formModel.MaterialType = "";
      }
      this.setMaterialTypeDisabled();
      this.setSupplierDisabled();
      this.updateFormValues("MaterialType", this.formModel.MaterialType);
    },

    setMaterialTypeDisabled() {
      document.querySelector(".material-type .dx-texteditor-input").disabled =
        this.formModel.ProductSource == "M" ? true : false;

      const selectBoxContainer = document.querySelector(".material-type");
      if (selectBoxContainer) {
        if (this.formModel.ProductSource == "M") {
          selectBoxContainer.classList.add("dx-state-disabled");
          this.$nextTick(() => {
            this.focusOnForm("SupplierCode");
          });
        } else {
          selectBoxContainer.classList.remove("dx-state-disabled");
          this.$nextTick(() => {
            this.focusOnForm("MaterialType");
          });
        }
      }
    },

    setWIPLeadDaysVisibility() {
      const wipLeadDaysContainer = document.querySelector(".wip-lead-days");
      if (wipLeadDaysContainer) {
        if (this.formModel.ProcessNominalTree) {
          wipLeadDaysContainer.style.display = "flex";
        } else {
          wipLeadDaysContainer.style.display = "none";
          this.formModel.WipLeadDays = 0;
          this.updateFormValues("WipLeadDays", this.formModel.WipLeadDays);
        }
      }
    },

    setSupplierDisabled() {
      if (this.formModel.MaterialType == "S") {
        this.formModel.SupplierCode = null;
        this.updateFormValues("SupplierCode", this.formModel.SupplierCode);
      }
      document.querySelector(".supplier-code .dx-texteditor-input").disabled =
        this.formModel.MaterialType == "S" ? true : false;
      //
      const selectBoxContainer = document.querySelector(".supplier-code");
      if (selectBoxContainer) {
        if (
          this.formModel.MaterialType == "S" &&
          this.formModel.ProductSource == "M"
        ) {
          selectBoxContainer.classList.add("dx-state-disabled");
          this.$nextTick(() => {
            this.focusOnForm("AutoIssueStrategy");
          });
        } else {
          selectBoxContainer.classList.remove("dx-state-disabled");
          if (this.formModel.ProductSource == "M") {
            this.$nextTick(() => {
              this.focusOnForm("SupplierCode");
            });
          }
        }
      }
    },

    onMaterialTypeSelectionChanged(e) {
      if (!e.event) return;
      this.formModel.MaterialType = e.value;
      //
      this.validateForm();
      this.setSupplierDisabled();
    },

    validateForm() {
      const form = this.$refs["split-view-form"].$refs["gc-form-comp"].instance;
      if (form) {
        form.validate();
      }
    },

    setStandardCost(productCode) {
      BillOfMaterialsService.getByCode(this.formModel.BillNo).then(
        (response1) => {
          if (response1.data.value.length > 0) {
            let branchCode = response1.data.value[0].BranchCode;
            //
            ProductCostService.getByCodeAndBranch(productCode, branchCode).then(
              (response2) => {
                if (response2.data.value.length > 0) {
                  this.formModel.StandardCost =
                    response2.data.value[0].StandardCost;
                  //
                  this.setTotalCost();
                }
              },
            );
          }
        },
      );
    },

    /**
     * Update Form Values
     * @param dataField Data Field
     * @param value Value
     */
    updateFormValues(dataField, value) {
      if (
        !this.$refs["split-view-form"] ||
        !this.$refs["split-view-form"].$refs["gc-form-comp"]
      )
        return;
      const form = this.$refs["split-view-form"].$refs["gc-form-comp"].instance;
      form.beginUpdate();
      form.updateData(dataField, value);
      form.endUpdate();
    },

    /**
     * On Quantity Value Changed
     * @param e Event
     */
    onQuantityValueChanged(e) {
      if (!e.event) return;

      this.formModel.Quantity = e.value;

      if (
        this.formModel.ProcessedQty == 0 &&
        this.formModel.YeildPercent == 0
      ) {
        this.formModel.ProcessedQty = this.formModel.Quantity;
        this.formModel.YeildPercent = 100;
        //
        this.updateFormValues("ProcessedQty", this.formModel.ProcessedQty);
        this.updateFormValues("YeildPercent", this.formModel.YeildPercent);
      }
      //
      if (this.formModel.Quantity == 0) {
        this.resetToZero();
      } else {
        this.setProcessedQuantity();
      }

      this.setStandardCost(this.formModel.Material);
    },

    onProcessNominalTreeChanged(e) {
      if (!e.event) return;
      this.formModel.ProcessNominalTree = e.value;
      if (e.value == false) {
        this.formModel.WipLeadDays = 0;
        this.updateFormValues("WipLeadDays", this.formModel.WipLeadDays);
      }
      this.setWIPLeadDaysVisibility();
    },

    onProcessedQtyChanged(e) {
      if (!e.event) return;

      this.formModel.ProcessedQty = e.value;
      //
      if (this.formModel.Quantity == 0 && this.formModel.YeildPercent == 0) {
        this.formModel.Quantity = this.formModel.ProcessedQty;
        this.formModel.YeildPercent = 100;
        //
        this.updateFormValues("Quantity", this.formModel.Quantity);
        this.updateFormValues("YeildPercent", this.formModel.YeildPercent);
      }
      //
      if (this.formModel.ProcessedQty == 0) {
        this.resetToZero();
      } else {
        this.setYeildPercent();
      }
    },

    onYeildPercentChanged(e) {
      if (!e.event) return;

      this.formModel.YeildPercent = e.value;
      if (this.formModel.YeildPercent == 0) {
        this.resetToZero();
      } else {
        this.setProcessedQuantity();
      }
    },

    setTotalCost() {
      this.formModel.TotalCost = (
        this.formModel.Quantity * this.formModel.StandardCost
      ).roundNumber(4);
      this.updateFormValues("TotalCost", this.formModel.TotalCost);
    },

    setProcessedQuantity() {
      this.formModel.ProcessedQty = (
        (this.formModel.Quantity * this.formModel.YeildPercent) /
        100
      ).roundNumber(4);
      this.updateFormValues("ProcessedQty", this.formModel.ProcessedQty);
    },

    setYeildPercent() {
      this.formModel.YeildPercent = (
        (this.formModel.ProcessedQty / this.formModel.Quantity) *
        100
      ).roundNumber(4);
      this.updateFormValues("YeildPercent", this.formModel.YeildPercent);
    },

    resetToZero() {
      this.formModel.Quantity = 0;
      this.formModel.ProcessedQty = 0;
      this.formModel.YeildPercent = 0;
      //
      this.updateFormValues("Quantity", this.formModel.Quantity);
      this.updateFormValues("ProcessedQty", this.formModel.ProcessedQty);
      this.updateFormValues("YeildPercent", this.formModel.YeildPercent);
    },

    /**
     * Delete Call Back
     */
    async deleteCallBack() {
      const confirmDelete = await this.$confirm(
        "Are you sure you want to delete this material from the Bill of Materials?",
        "Confirm Delete",
      );
      if (confirmDelete) {
        this.showLoading(true);

        try {
          const response = await BillOfMaterialsService.deleteBomMaterial(
            this.baseView.id,
          );

          if (response) {
            this.$nextTick(() => {
              this.setIgnoreRouteChangeConfirmation();
              this.$router
                .push({
                  path: this.getFormBackURL,
                })
                .then(() => {
                  this.$refs["data-grid"].instance.refresh(true);
                });
            });
          }
        } catch (error) {
          this.displayServerError(
            error,
            "Error deleting material from Bill of Materials",
          );
        } finally {
          this.showLoading(false);
        }
      }
    },

    onSaveMaterial(action) {
      this.SaveType = action.itemData.text;
      this.isValid = true;
    },
  },
  watch: {
    getHotKeySave(newVal) {
      if (newVal) {
        this.$store.dispatch("hotKey/setHotKeySave", false);
        this.onSaveMaterial({ itemData: { text: "Save + Add New" } });
      }
    },
  },
};
</script>

<style lang="scss">
.bill-of-materials {
  .pack-size {
    padding-right: 0 !important;
  }
  .batch-size {
    padding-left: 10 !important;
    > label {
      // width: 75px !important;
    }
  }
}
</style>
